"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionStatusModalCtrl = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var CollectionStatusModalCtrl = /** @class */ (function () {
    function CollectionStatusModalCtrl(collections) {
        this.pq = new core_shared_1.IkePromiseQueue(services_1.Logger, 10);
        this.settingStatus = false;
        this.collections = collections;
    }
    CollectionStatusModalCtrl.prototype.SetStatusCollections = function (status, allStatuses) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newCollectionUuids, _loop_1, this_1, _i, _a, collection;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.settingStatus) {
                            return [2 /*return*/];
                        }
                        this.setSettingStatus(true);
                        newCollectionUuids = [];
                        _loop_1 = function (collection) {
                            var allStatusesForCollection = allStatuses.find(function (e) { return e.collectionId === collection.objectId; });
                            if (allStatusesForCollection) {
                                if (status === null || allStatusesForCollection.statuses.indexOf(status) > -1) {
                                    this_1.pq.add(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                        var uuid;
                                        return tslib_1.__generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, this.updateCollectionStatus(collection, allStatusesForCollection, status)];
                                                case 1:
                                                    uuid = _a.sent();
                                                    newCollectionUuids.push(uuid);
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                }
                            }
                        };
                        this_1 = this;
                        for (_i = 0, _a = this.collections; _i < _a.length; _i++) {
                            collection = _a[_i];
                            _loop_1(collection);
                        }
                        return [4 /*yield*/, this.pq.join()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, page_state_1.CurrentState.updateInspectedCollection()];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.refresh(newCollectionUuids)];
                    case 3:
                        _b.sent();
                        this.setSettingStatus(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionStatusModalCtrl.prototype.updateCollectionStatus = function (collection, allStatusesForCollection, status) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, collectionJson, newCollection;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = services_1.Services.Department.rest;
                        return [4 /*yield*/, rest.Collection.getByRevision(collection.revision).fetch()];
                    case 1:
                        collectionJson = _a.sent();
                        collectionJson.data.data[allStatusesForCollection.statusFieldId] = status ? [status.split(' > ')] : [];
                        return [4 /*yield*/, rest.save(rest.Objects.Collection, collectionJson)];
                    case 2:
                        newCollection = _a.sent();
                        return [2 /*return*/, newCollection.uuid];
                }
            });
        });
    };
    CollectionStatusModalCtrl.prototype.refresh = function (collectionUuids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectionSummaries;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(collectionUuids.map(function (uuid) { return store_1.AppStore.CollectionSummary.getFetchableByUuid(uuid).refetch(); }))];
                    case 1:
                        collectionSummaries = _a.sent();
                        return [2 /*return*/, Promise.all(tslib_1.__spreadArray([
                                store_1.AppStore.Tag.refresh()
                            ], this.getTagIds(collectionSummaries).map(function (tagId) { return store_1.AppStore.TagSummary.getFetchable(tagId).refetch(); }), true))];
                }
            });
        });
    };
    CollectionStatusModalCtrl.prototype.getTagIds = function (collectionSummaries) {
        var tags = {};
        for (var _i = 0, collectionSummaries_1 = collectionSummaries; _i < collectionSummaries_1.length; _i++) {
            var collectionSummary = collectionSummaries_1[_i];
            for (var _a = 0, _b = collectionSummary.tags; _a < _b.length; _a++) {
                var tag = _b[_a];
                if (!tags[tag] && !(0, core_api_1.isSystemTag)(tag)) {
                    tags[tag] = true;
                }
            }
        }
        return Object.keys(tags);
    };
    CollectionStatusModalCtrl.prototype.setSettingStatus = function (settingStatus) {
        this.settingStatus = settingStatus;
    };
    CollectionStatusModalCtrl.prototype.getActualStatuses = function () {
        var statuses = [];
        for (var _i = 0, _a = page_state_1.CurrentState.Tag.collections; _i < _a.length; _i++) {
            var summary = _a[_i];
            if (summary.status === 'undefined' || summary.status === '') {
                statuses.push('undefined');
            }
            else {
                statuses.push(summary.status);
            }
        }
        var result = statuses.reduce(function (allStatuses, status) {
            if (status in allStatuses) {
                allStatuses[status]++;
            }
            else {
                allStatuses[status] = 1;
            }
            return allStatuses;
        }, {});
        return result;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionStatusModalCtrl.prototype, "tagName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionStatusModalCtrl.prototype, "settingStatus", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionStatusModalCtrl.prototype, "setSettingStatus", null);
    return CollectionStatusModalCtrl;
}());
exports.CollectionStatusModalCtrl = CollectionStatusModalCtrl;
//# sourceMappingURL=collection.status.modal.ctrl.js.map